<!-- Modal Header -->
<div class="modal-header border-0 pb-2">
  <div class="d-flex align-items-center flex-grow-1">
    <div class="registration-icon me-3">
      <i class="bi bi-arrow-repeat"></i>
    </div>
    <div>
      <h4 class="modal-title mb-1">คำขอต่ออายุบัตรสมาชิก</h4>
      <p class="text-muted mb-0 small">ระบบการจัดเก็บและจัดการ CPD Hours • สำหรับสมาชิกสมาคมผู้ประเมินค่าทรัพย์สินไทย
      </p>
    </div>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<!-- Progress Bar -->
<div class="modal-progress">
  <div class="progress">
    <div class="progress-bar bg-success" role="progressbar" [style.width.%]="progressPercentage"
      [attr.aria-valuenow]="progressPercentage" aria-valuemin="0" aria-valuemax="100">
    </div>
  </div>
  <div class="progress-steps">
    <div class="step-container">
      <div *ngFor="let step of [1, 2]" class="step-item">
        <div class="step-circle" [class.completed]="isStepCompleted(step)" [class.current]="currentStep === step"
          [class.clickable]="step <= currentStep" (click)="goToStep(step)">
          <i *ngIf="isStepCompleted(step)" class="bi bi-check-lg"></i>
          <i *ngIf="currentStep === step && step === 1" class="bi bi-file-earmark-text"></i>
          <i *ngIf="currentStep === step && step === 2" class="bi bi-person-check"></i>
          <span *ngIf="!isStepCompleted(step) && currentStep !== step">{{ step }}</span>
        </div>
        <div class="step-label">{{ step === 1 ? 'ประเภทการต่ออายุ' : 'ข้อมูลสมาชิกทำบัตรสมาชิกใหม่' }}</div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body">

  <form [formGroup]="renewForm" (ngSubmit)="onSubmit()">

    <!-- Step 1: Renewal Years Input -->
    <div class="step-content" *ngIf="currentStep === 1">
      <div class="step-header">
        <h5 class="step-title">
          <i class="bi bi-file-earmark-text me-2"></i>ขั้นตอนที่ 1. ประเภทการต่ออายุ
        </h5>
        <p class="step-description">เลือกประเภทการต่ออายุสมาชิก (รายปี หรือ ตลอดชีพ)</p>
      </div>

      <div class="row">
        <!-- ประเภทการต่ออายุ -->
        <div class="col-12 mb-3">
          <label class="form-label required">ประเภทการต่ออายุ</label>
          <div class="renew-type-options">
            <div *ngFor="let type of renewTypes" class="form-check p-3 border rounded mb-2"
              [class.border-primary]="renewForm.get('renewType')?.value === type.value"
              style="background-color: #f8f9fa;">
              <input class="form-check-input" type="radio" formControlName="renewType" [value]="type.value"
                [id]="'renew-type-' + type.value">
              <label class="form-check-label w-100" [for]="'renew-type-' + type.value" style="cursor: pointer;">
                <span class="d-block fw-semibold">{{ type.label }}</span>
                <small class="text-muted">{{ type.description }}</small>
              </label>
            </div>
          </div>
        </div>

        <!-- จำนวนปี: เฉพาะการต่ออายุรายปี -->
        <div class="col-md-6 mb-3" *ngIf="!isLifetimeRenewal">
          <label class="form-label required">จำนวนปีที่ต้องการต่ออายุ</label>
          <input type="number" class="form-control" formControlName="renewYears"
            [class.is-invalid]="renewForm.get('renewYears')?.invalid && renewForm.get('renewYears')?.touched"
            placeholder="กรอกจำนวนปี" min="1">
          <div class="invalid-feedback"
            *ngIf="renewForm.get('renewYears')?.invalid && renewForm.get('renewYears')?.touched">
            กรุณากรอกจำนวนปีที่ต้องการต่ออายุ
          </div>
        </div>

        <!-- สรุปค่าธรรมเนียม -->
        <div class="col-md-6 mb-3">
          <label class="form-label">ค่าธรรมเนียมที่ต้องชำระ</label>
          <div class="form-control bg-light fw-bold" style="font-size: 1.1rem;">
            {{ calculatedFee | number }} บาท
          </div>
          <small class="text-muted d-block mt-1">
            <i class="bi bi-info-circle me-1"></i>
            {{ isLifetimeRenewal
              ? 'ค่าธรรมเนียม 5,000 บาท + VAT 7% = 5,350 บาท'
              : 'ค่าธรรมเนียม 500 บาทต่อปี + VAT 7% = 535 บาทต่อปี' }}
          </small>
        </div>

        <div class="col-12 mb-3">
          <label class="form-label">เอกสารประกอบการพิจารณา</label>
          <p class="text-muted small mb-3">
            <i class="bi bi-info-circle me-1"></i>
            อัพโหลดไฟล์ประเภท PDF, JPG, JPEG หรือ PNG (ขนาดไม่เกิน 5MB)
          </p>
          <div class="document-upload-list">
            <div *ngFor="let doc of documentTypes" class="document-upload-item">
              <div class="document-info">
                <div class="document-number">{{ doc.value }}</div>
                <div class="document-details">
                  <div class="document-title">{{ doc.label.substring(doc.label.indexOf('.') + 1).trim() }}</div>
                  <div class="document-status" *ngIf="hasFile(doc.value)">
                    <i class="bi bi-check-circle-fill text-success me-1"></i>
                    <span class="file-name">{{ getFileName(doc.value) }}</span>
                    <span class="file-size text-muted ms-2">({{ getFileSize(doc.value) }})</span>
                  </div>
                  <div class="document-status text-muted" *ngIf="!hasFile(doc.value)">
                    <i class="bi bi-upload me-1"></i>
                    <span>ยังไม่ได้อัพโหลด</span>
                  </div>
                </div>
              </div>
              <div class="document-actions">
                <input type="file" #fileInput [id]="'file-' + doc.value" class="file-input"
                  accept=".pdf,.jpg,.jpeg,.png" (change)="onFileSelect($event, doc.value)" hidden>
                <button type="button" class="btn btn-upload btn-sm" *ngIf="!hasFile(doc.value)"
                  (click)="fileInput.click()">
                  <i class="bi bi-cloud-upload me-1"></i>เลือกไฟล์
                </button>
                <button type="button" class="btn btn-remove-file btn-sm" *ngIf="hasFile(doc.value)"
                  (click)="removeFile(doc.value)">
                  <i class="bi bi-trash me-1"></i>ลบไฟล์
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Step 2: Member Information Review -->
    <div class="step-content" *ngIf="currentStep === 2">
      <div class="step-header">
        <h5 class="step-title">
          <i class="bi bi-person-check me-2"></i>ขั้นตอนที่ 2. ข้อมูลสมาชิกต่ออายุ
        </h5>
        <p class="step-description">ตรวจสอบข้อมูลสมาชิกให้ถูกต้อง</p>
      </div>

      <!-- Top Zone: Member Info and Fee -->
      <div class="card mb-4" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border: none;">
        <div class="card-body text-white p-4">
          <div class="row align-items-center">
            <div class="col-md-6">
              <h6 class="mb-3" style="border-bottom: 2px solid rgba(255,255,255,0.3); padding-bottom: 10px;">
                <i class="bi bi-person-badge me-2"></i>ข้อมูลสมาชิกต่ออายุ
              </h6>
              <div class="d-flex align-items-center mb-2">
                <div
                  style="background: rgba(255,255,255,0.2); padding: 8px 12px; border-radius: 8px; min-width: 120px;">
                  <small style="opacity: 0.9;">{{ isLifetimeRenewal ? 'ประเภทการต่ออายุ' : 'จำนวนปีที่ต้องการต่ออายุ' }}</small>
                </div>
                <div class="ms-3">
                  <h4 class="mb-0">{{ isLifetimeRenewal ? 'ตลอดชีพ' : (renewForm.get('renewYears')?.value || '0') }}</h4>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div
                  style="background: rgba(255,255,255,0.2); padding: 8px 12px; border-radius: 8px; min-width: 120px;">
                  <small style="opacity: 0.9;">เอกสารประกอบการพิจารณา</small>
                </div>
                <div class="ms-3">
                  <span class="badge bg-light text-dark">1. แบบไฟล์ รูปถ่าย 1 ตัว หน้าตรง สำหรับ ทำบัตร</span>
                </div>
              </div>
            </div>
            <div class="col-md-6 text-md-end">
              <div
                style="background: rgba(255,255,255,0.15); padding: 20px; border-radius: 12px; border: 2px solid rgba(255,255,255,0.3);">
                <small style="opacity: 0.9; display: block; margin-bottom: 8px;">ค่าธรรมเนียมที่ต้องชำระ</small>
                <h2 class="mb-0" style="font-weight: 700;">{{ calculatedFee | number }} บาท (รวม vat)</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </form>
</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="previousStep()" *ngIf="currentStep > 1"
    [disabled]="isSubmitting">
    <i class="bi bi-arrow-left me-1"></i>ย้อนกลับ
  </button>
  <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="isSubmitting">
    ยกเลิก
  </button>
  <button type="button" class="btn btn-success" (click)="nextStep()" *ngIf="currentStep < totalSteps"
    [disabled]="isSubmitting">
    ถัดไป<i class="bi bi-arrow-right ms-1"></i>
  </button>
  <button type="button" class="btn btn-success" (click)="onSubmit()" *ngIf="currentStep === totalSteps"
    [disabled]="isSubmitting || renewForm.invalid">
    <span *ngIf="!isSubmitting">
      <i class="bi bi-check-circle me-1"></i>ปุ่มชั้นคอนเฟิร์ม
    </span>
    <span *ngIf="isSubmitting">
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      กำลังส่งข้อมูล...
    </span>
  </button>
</div>